export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteDialog.json?hash=27cf8a22855e076432195d67f9c115c2";